/** @jsxImportSource @emotion/react */
import { useRef } from "react";
import { onFileSelection } from "../helper";
import { useContext } from "react";
import { Il8nContext } from '../../../Helper/i18n';

function Upload(props) {
  const { onFile, accept, setSnackBar, documentData, index, active, activeImage, image, boxStyle, limitPdfPages } = props;
  const localeText = useContext(Il8nContext)

  const upload = useRef(null);

  async function handleInputChange() {
    if (!upload.current.files[0]) {
      setSnackBar({ show: true, message: localeText?.uploadValid, type: 'error' });
      return;
    }

    var reader = new FileReader();
    reader.readAsBinaryString(upload.current.files[0]);

    reader.onloadend = async function () {
      if(typeof(limitPdfPages) === 'number'){
        var count = (reader.result.match(/\/Type[\s]*\/Page[^s]/g) || []).length;

        if (count > limitPdfPages) {
          setSnackBar({ show: true, message: localeText?.uploadPdfPagesLimitStart + `${limitPdfPages}` + localeText?.uploadPdfPagesLimitEnd, type: 'error' });
          return;
        }
      }

      if (upload.current.files[0]) {
        let response = await onFileSelection(upload.current.files[0])
        if (response.data) {
          onFile(response, documentData);
        } else {
          setSnackBar(response)
        }
      } else {
        setSnackBar({ show: true, message: localeText?.uploadValid, type: 'error' })
      }
    };
  }

  return (
    <div tabindex={index} title={documentData?.documentName || ''} style={boxStyle} onClick={() => upload.current.click()}>
      <input ref={upload} type='file' accept={accept || '.png, .jpg, .jpeg, .pdf, .svg'} style={{ display: 'none' }} onChange={handleInputChange} />
      <div tabindex={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
        <img src={index === active ? activeImage : image} style={{ margin: '0px' }} alt='' />
        <p style={{ ...(index === active ? { color: '#fff' } : { color: '#999999' }), fontSize: '11px', height: '50px', overflow: 'hidden', textAlign: 'center' }}>
          {documentData?.documentName || ''}
        </p>
      </div>
    </div>
  )
}
export default Upload;